<div class="form-group" *ngIf="(progressImageVal$ | async) > 0">
  <div class="progress">
    <div class="progress-bar" [style.width.%]="progressImageVal$ | async">{{ progressImageVal$ | async }}%</div>
  </div>
</div>
